import {Box, Button, Typography} from "@mui/material";
import React, {ReactNode, useEffect, useRef} from "react";
import Logo from "../../images/HeaderLogoPro.png";

const PrintReport = ({
  isPrinting,
  title,
  details,
  children
} : {
  isPrinting: boolean
  title: string
  details: ReactNode
  children: ReactNode
}) => {

  const getPageStyle = () => {
    return `@page { size: landscape; margin: 16px !important; }`;
  }

  return (
    <Box>
      <style>{getPageStyle()}</style>
      {isPrinting &&
        <Box display="flex" justifyContent="space-between" mt={1} mb={1}>
          <Box display="flex" flexDirection="column" justifyContent="flex-start">
            <Typography variant="h3" color="primary" gutterBottom>{title}</Typography>
            {details}
          </Box>
          <Box display="flex">
            <img src={Logo} alt="logo" height={50}/>
          </Box>
        </Box>
      }
      {children}
    </Box>
  )
}

export default PrintReport
